import { Box, styled } from "@mui/material";

export const StyledCreateInvoice = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  ".invoiceFormWrapper": {
    padding: "2rem",
    boxSizing: "border-box",
    width: "100%",
    overflowY: "scroll",
    ".invoiceSettings": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "2rem",
      button: {
        width: "5rem",
        height: "5rem",
        padding: "0",
        background: theme.color.dark
      },
      ".toggled": {
        background: theme.color.main
      }
    }
  }
}));
